import React, { Component } from "react";
import Images from "../../../components/common/Images";
import { Button } from "antd";
import { useMediaQuery } from "react-responsive";
import { AppConfig } from "../../../helpers";
import moment from "moment";
const IsMobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 500 });
  return isMobile ? children : null;
};
const IsMiddleScreenAndDesktop = ({ children }) => {
  const isMobile = useMediaQuery({ minWidth: 501 });
  return isMobile ? children : null;
};
export class HomeResultsRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countdown1: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      countdown2: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
    };
  }

  componentDidMount() {
    this.updateCountdown();
    this.countdownInterval = setInterval(this.updateCountdown, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.countdownInterval);
  }

  navToSingleMatch = (eventId) => {
    const { history } = this.props;
    history.push(`/lucky-numbers/15/108/drilldown/${eventId}`);
  };

  updateCountdown = () => {
    const { item1, item2 } = this.props;
    const now = moment.utc();

    if (item1) {
      const targetDate1 = moment.utc(item1.eventDateOfMatch);
      if (now.isBefore(targetDate1)) {
        const duration1 = moment.duration(targetDate1.diff(now));
        const hours1 = Math.floor(duration1.asHours());
        const minutes1 = duration1.minutes();
        const seconds1 = duration1.seconds();

        this.setState({
          countdown1: {
            hours: hours1 < 10 ? "0" + hours1 : hours1,
            minutes: minutes1 < 10 ? "0" + minutes1 : minutes1,
            seconds: seconds1 < 10 ? "0" + seconds1 : seconds1,
          },
        });
      } else {
        this.setState({
          countdown1: {
            hours: "00",
            minutes: "00",
            seconds: "00",
          },
        });
      }
    }

    if (item2) {
      const targetDate2 = moment.utc(item2.eventDateOfMatch);
      if (now.isBefore(targetDate2)) {
        const duration2 = moment.duration(targetDate2.diff(now));
        const hours2 = Math.floor(duration2.asHours());
        const minutes2 = duration2.minutes();
        const seconds2 = duration2.seconds();

        this.setState({
          countdown2: {
            hours: hours2 < 10 ? "0" + hours2 : hours2,
            minutes: minutes2 < 10 ? "0" + minutes2 : minutes2,
            seconds: seconds2 < 10 ? "0" + seconds2 : seconds2,
          },
        });
      } else {
        this.setState({
          countdown2: {
            hours: "00",
            minutes: "00",
            seconds: "00",
          },
        });
      }
    }
  };
  calculateDays = (hours) => {
    if (hours <= 24) {
      return "00";
    } else {
      let days = Math.floor(hours / 24);
      return days.toString().padStart(2, "0");
    }
  };

  render() {
    const { item1, item2, fromResult } = this.props;

    const item1Flag = item1
      ? item1.countryFlagCode
        ? item1.countryFlagCode
        : item1.eventCategory
        ? item1.eventCategory.categoryFlagCode
        : "eu"
      : "eu";
    const item2Flag = item2
      ? item2.countryFlagCode
        ? item2.countryFlagCode
        : item2.eventCategory
        ? item2.eventCategory.categoryFlagCode
        : "eu"
      : "eu";

    return (
      <div className="result-row">
        {item1 && (
          <div className="section">
            <div className="justify-content">
              <IsMiddleScreenAndDesktop>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={AppConfig.countryFlagImagesPath + item1Flag + (this.props.fromKiosk ? `.png` : `.webp`)}
                    alt="country-flag"
                  />
                  <div
                    style={{ display: "inline-flex", flexDirection: "column" }}
                  >
                    <span className="team">
                      {item1.eventName ||
                        item1.eventTournament.tournamentDisplayName}
                    </span>
                    {!this.props.fromKiosk ? (
                      <span style={{ opacity: 0.5, fontSize: "12px" }}>
                        ID: {item1.eventId}
                      </span>
                    ) : (
                      <div className="date">
                        {moment
                          .utc(item1.eventDateOfMatch)
                          .format("DD MMM YYYY, HH:mm:ss")}
                      </div>
                    )}
                    {this.props.fromKiosk &&        <span style={{ opacity: 0.5, fontSize: "12px" }}>
                        ID: {item1.eventId}
                      </span>}
                  </div>
                </div>{" "}
                {!this.props.fromKiosk && (
                  <div className="date">
                    {moment
                      .utc(item1.eventDateOfMatch)
                      .format("DD MMM YYYY, HH:mm:ss")}
                  </div>
                )}
              </IsMiddleScreenAndDesktop>
              <IsMobile>
                <div className="mobile-team-details">
                  <img
                    src={AppConfig.countryFlagImagesPath + item1Flag + (this.props.fromKiosk ? `.png` : `.webp`)}
                    alt="country-flag"
                  />
                  <div className="column-direction">
                    <div
                      style={{
                        display: "inline-flex",
                        flexDirection: "column",
                      }}
                    >
                      <span className="team">
                        {item1.eventName ||
                          item1.eventTournament.tournamentDisplayName}
                      </span>
                      <span style={{ opacity: 0.5, fontSize: "12px" }}>
                        ID: {item1.eventId}
                      </span>
                    </div>
                    <div className="date">
                      {moment
                        .utc(item1.eventDateOfMatch)
                        .format("DD MMM YYYY, HH:mm:ss")}
                    </div>
                  </div>
                </div>{" "}
                <div className="bet-button">
                  {!fromResult && !this.props.fromKiosk && (
                    <Button
                      disabled={!item1.enableBet}
                      style={
                        this.props.fromNextDraws && !item1.enableBet
                          ? { backgroundColor: "red" }
                          : {}
                      }
                      onClick={() => this.navToSingleMatch(item1.eventId)}
                    >
                      {this.props.fromNextDraws
                        ? item1.enableBet
                          ? `BET`
                          : `CLOSED`
                        : `BET`}
                    </Button>
                  )}
                </div>
              </IsMobile>
            </div>
            <div className="justify-content">
              <div className="circles-container">
                {!this.props.fromNextDraws && item1.ballResults ? (
                  item1.ballResults.map((item, idx) => {
                    return (
                      <span
                        className={`circles ${item.ballType == 2 &&
                          `bonus-ball`}`}
                        key={`${item.ballValue}- ${idx}`}
                      >
                        {item.ballValue}
                      </span>
                    );
                  })
                ) : (
                  <div className="next-draw-timer">
                    {this.state.countdown1.hours > 24 && (
                      <div className="time">
                        <div className="number">
                          {this.calculateDays(this.state.countdown1.hours)}
                        </div>
                        <div className="text">Day</div>
                      </div>
                    )}
                    <div className="time">
                      <div className="number">
                        {this.state.countdown1.hours}
                      </div>
                      <div className="text">HOUR</div>
                    </div>
                    <div className="time">
                      <div className="number">
                        {this.state.countdown1.minutes}
                      </div>
                      <div className="text">MIN</div>
                    </div>
                    <div className="time">
                      <div className="number">
                        {this.state.countdown1.seconds}
                      </div>
                      <div className="text">SEC</div>
                    </div>
                  </div>
                )}
              </div>{" "}
              <IsMiddleScreenAndDesktop>
                <div className="bet-button">
                  {!fromResult && !this.props.fromKiosk && (
                    <Button
                      disabled={!item1.enableBet}
                      style={
                        this.props.fromNextDraws && !item1.enableBet
                          ? { backgroundColor: "red" }
                          : {}
                      }
                      onClick={() => this.navToSingleMatch(item1.eventId)}
                    >
                      {this.props.fromNextDraws
                        ? item1.enableBet
                          ? `BET`
                          : `CLOSED`
                        : `BET`}
                    </Button>
                  )}
                </div>
              </IsMiddleScreenAndDesktop>
            </div>
            {item1.eventCancelled && (
              <img src={Images.CanceledEvent} className="canceled-image" />
            )}
          </div>
        )}
        {item2 && (
          <div className="section">
            <div className="justify-content">
              <IsMiddleScreenAndDesktop>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={AppConfig.countryFlagImagesPath + item2Flag + (this.props.fromKiosk ? `.png` : `.webp`)}
                    alt="country-flag"
                  />
                  <div
                    style={{
                      display: "inline-flex",
                      flexDirection: "column",
                    }}
                  >
                    <span className="team">
                      {item2.eventName ||
                        item2.eventTournament.tournamentDisplayName}
                    </span>
                    <span style={{ opacity: 0.5, fontSize: "12px" }}>
                      ID: {item2.eventId}
                    </span>
                  </div>
                </div>{" "}
                <div className="date">
                  {moment
                    .utc(item2.eventDateOfMatch)
                    .format("DD MMM YYYY, HH:mm:ss")}
                </div>
              </IsMiddleScreenAndDesktop>
              <IsMobile>
                <div className="mobile-team-details">
                  <img
                    src={AppConfig.countryFlagImagesPath + item2Flag + (this.props.fromKiosk ? `.png` : `.webp`)}
                    alt="country-flag"
                  />
                  <div className="column-direction">
                    <div
                      style={{
                        display: "inline-flex",
                        flexDirection: "column",
                      }}
                    >
                      <span className="team">
                        {item2.eventName ||
                          item2.eventTournament.tournamentDisplayName}
                      </span>
                      <span style={{ opacity: 0.5, fontSize: "12px" }}>
                        ID: {item2.eventId}
                      </span>
                    </div>
                    <div className="date">
                      {moment
                        .utc(item2.eventDateOfMatch)
                        .format("DD MMM YYYY, HH:mm:ss")}
                    </div>
                  </div>
                </div>{" "}
                <div className="bet-button">
                  {!fromResult && !this.props.fromKiosk && (
                    <Button
                      disabled={!item2.enableBet}
                      style={
                        this.props.fromNextDraws && !item2.enableBet
                          ? { backgroundColor: "red" }
                          : {}
                      }
                      onClick={() => this.navToSingleMatch(item2.eventId)}
                    >
                      {this.props.fromNextDraws
                        ? item2.enableBet
                          ? `BET`
                          : `CLOSED`
                        : `BET`}
                    </Button>
                  )}
                </div>
              </IsMobile>
            </div>
            <div className="justify-content">
              <div className="circles-container">
                {!this.props.fromNextDraws && item2.ballResults ? (
                  item2.ballResults.map((item, idx) => {
                    return (
                      <span
                        className={`circles ${item.ballType == 2 &&
                          `bonus-ball`}`}
                        key={`${item.ballValue}- ${idx}`}
                      >
                        {item.ballValue}
                      </span>
                    );
                  })
                ) : (
                  <div className="next-draw-timer">
                    {this.state.countdown2.hours > 24 && (
                      <div className="time">
                        <div className="number">
                          {this.calculateDays(this.state.countdown2.hours)}
                        </div>
                        <div className="text">Day</div>
                      </div>
                    )}
                    <div className="time">
                      <div className="number">
                        {this.state.countdown2.hours}
                      </div>
                      <div className="text">HOUR</div>
                    </div>
                    <div className="time">
                      <div className="number">
                        {this.state.countdown2.minutes}
                      </div>
                      <div className="text">MIN</div>
                    </div>
                    <div className="time">
                      <div className="number">
                        {this.state.countdown2.seconds}
                      </div>
                      <div className="text">SEC</div>
                    </div>
                  </div>
                )}
              </div>{" "}
              <IsMiddleScreenAndDesktop>
                <div className="bet-button">
                  {!fromResult && !this.props.fromKiosk && (
                    <Button
                      disabled={!item2.enableBet}
                      style={
                        this.props.fromNextDraws && !item2.enableBet
                          ? { backgroundColor: "red" }
                          : {}
                      }
                      onClick={() => this.navToSingleMatch(item2.eventId)}
                    >
                      {this.props.fromNextDraws
                        ? item2.enableBet
                          ? `BET`
                          : `CLOSED`
                        : `BET`}
                    </Button>
                  )}
                </div>
              </IsMiddleScreenAndDesktop>
            </div>
            {item2.eventCancelled && (
              <img src={Images.CanceledEvent} className="canceled-image" />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default HomeResultsRow;
